import { createSelector } from "reselect";

import { AdminUserListModelWithTeams, AppState } from "./model";

export const routeIdSelector = (state: AppState) => {
    return state.router.params.adminUserId;
};

export type SelectorState = AppState;

export const adminUsersWithTeamsSelector = (state: AppState) => state.adminUsersWithTeams;

export const adminUserSelector = createSelector(
    adminUsersWithTeamsSelector,
    routeIdSelector,
    (adminUsersWithTeams: AdminUserListModelWithTeams[], id: string) => {
        return adminUsersWithTeams.filter(c => c.id === id)[0] || {} as AdminUserListModelWithTeams;
    }
);
